import api, { authHeader } from "@/store/api";

const pet = {
  namespaced: true,
  state: () => ({
    uid: undefined,
    session: undefined,
    data: {},
    status: 0,
    breeds: { cachedAt: null },
    foods: { cachedAt: null },
  }),
  getters: {
    isRestrict: (state) => (field) =>
      (state.data.camposRestritos ? state.data.camposRestritos : "")
        .split(",")
        .includes(field),
  },
  mutations: {
    setData: (state, payload) => (state.data = payload),
    setUID: (state, payload) => (state.uid = payload),
    setSession: (state, payload) => (state.session = payload),
    setStatus: (state, payload) => (state.status = payload),
    setBreeds: (state, payload) => {
      payload.specie &&
        (state.breeds[payload.specie] = payload.data) &&
        (state.breeds.cachedAt = payload.cachedAt);
    },
    setFoods: (state, payload) => {
      payload.data &&
        (state.foods.data = payload.data) &&
        (state.foods.cachedAt = payload.cachedAt);
    },
  },
  actions: {
    checkIn({ commit }, { uid, callbackSuccess, callbackError }) {
      commit("setStatus", 1);
      const time = setTimeout(() => {
        api
          .post(`api/pet/checkin?uid=${uid}`)
          .then((result) => {
            commit("setSession", result.data.content.token);
            commit("setStatus", !result.data.content.token ? 3 : 0);
            callbackSuccess && callbackSuccess(result);
          })
          .catch((err) => {
            console.error(err);
            callbackError && callbackError(err);
            commit("setStatus", 2);
          });
        clearTimeout(time);
      }, 3000);
    },
    uploadFile({ state }, { file, key, token, callback, callbackError }) {
      let parseKey;

      switch (key) {
        case "fotoPerfil":
          parseKey = "profileImage";
          break;
        case "prontuarioMedico":
          parseKey = "medicalDocuments";
          break;
        case "carteiraVacinacao":
          parseKey = "vaccineDocuments";
          break;
        case "carteiraConvenio":
          parseKey = "healthInsuranceDocuments";
          break;
        case "carteiraDoador":
          parseKey = "donorDocuments";
          break;
      }

      const formData = new FormData();
      formData.append("file", file);

      api
        .post("api/upload-file", formData, {
          headers: {
            id: parseKey + "/" + state.uid,
            key: parseKey,
            "Content-Type": "multipart/form-data",
            ...authHeader(token),
          },
        })
        .then((result) => {
          callback({
            result: {
              ...state.data,
              ...{ [key]: result.data.fileDownloadUri },
            },
            // afterCallback: () => window.location.reload(true),
          });
        })
        .catch((err) => {
          console.error(err);
          callbackError && callbackError(err);
        });
    },
    updateData(
      { commit, state },
      { register, token, callbackSuccess, callbackError }
    ) {
      api
        .put(
          `api/pet?id=${state.uid}`,
          { ...state.data, ...register },
          {
            headers: authHeader(token),
          }
        )
        .then(() => {
          commit("setData", { ...state.data, ...register });
          callbackSuccess && callbackSuccess();
        })
        .catch((err) => {
          console.error(err);
          callbackError && callbackError(err);
        });
    },
    getQRCodeImage({ state }, { callbackSuccess, callbackError, token }) {
      api
        .get(`api/qrcode/image/pet/${state.uid.replace("app/pet/", "")}`, {
          headers: authHeader(token),
        })
        .then((result) => {
          callbackSuccess && callbackSuccess(result.data.content.imgBase64);
        })
        .catch((err) => {
          console.error(err);
          callbackError && callbackError(err);
        });
    },
    getAdminData({ commit, state }, { callbackSuccess, callbackError, token }) {
      commit("setStatus", 1);
      api
        .get(`api/pet/admin?id=${state.uid}`, {
          headers: authHeader(token),
        })
        .then((result) => {
          commit("setStatus", 0);
          commit("setData", result.data.content);
          callbackSuccess && callbackSuccess(result.data.content);
        })
        .catch((err) => {
          commit("setStatus", -1);
          console.error(err);
          callbackError && callbackError(err);
        });
    },
    getData({ commit, state }, { callbackSuccess, callbackError }) {
      commit("setStatus", 1);
      api
        .get(`api/pet?id=${state.uid}`)
        .then((result) => {
          commit("setStatus", 0);
          commit("setData", result.data.content);
          callbackSuccess && callbackSuccess(result.data.content);
        })
        .catch((err) => {
          commit("setStatus", -1);
          console.error(err);
          callbackError && callbackError(err);
        });

      // Modelo Pet
      //
      // alergias
      // carteiraVacinacao
      // castrado
      // doencas
      // empresaVeterinario
      // foneCuidador
      // foneDono
      // foneVeterinario
      // fotoPerfil
      // id
      // idade
      // informacoes
      // marcaRacao
      // medicamentos
      // nome
      // nomeCuidador
      // nomeDono
      // nomeVeterinario
      // observacao
      // pedigree
      // prontuarioMedico
      // raca
      // tipoRacao
    },
  },
};

export default pet;
